var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmployeeGraphic = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 96,
  height: 96,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 1.5,
  y: 1.5,
  width: 93,
  height: 93,
  rx: 46.5,
  fill: "#E1EFFF"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 1.5,
  y: 1.5,
  width: 93,
  height: 93,
  rx: 46.5,
  stroke: "#650030",
  strokeWidth: 3
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#employee-graphic_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.424 20.391c-.664 0-1.301.262-1.77.727a2.472 2.472 0 0 0-.734 1.756v49.074c0 .658.264 1.29.733 1.755.47.466 1.107.727 1.77.727h35.154c.664 0 1.301-.261 1.77-.727.47-.465.734-1.097.734-1.755V22.874c0-.659-.264-1.29-.733-1.756a2.514 2.514 0 0 0-1.77-.727H53.238v-.038H42.917v.038H30.424Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48 28.75c6.745 0 12.25 5.262 12.25 11.751S54.745 52.25 48 52.25s-12.25-5.265-12.25-11.752c0-6.487 5.505-11.748 12.25-11.748Zm-.36 2.46a9.986 9.986 0 0 0-5.045 1.57 9.425 9.425 0 0 0-3.575 4.197 8.997 8.997 0 0 0-.546 5.393 9.23 9.23 0 0 0 2.667 4.778 9.846 9.846 0 0 0 4.985 2.55c1.889.356 3.845.165 5.62-.549a9.638 9.638 0 0 0 4.35-3.458 9.074 9.074 0 0 0 1.616-5.192c-.008-2.466-1.033-4.83-2.853-6.574C53.04 32.18 50.573 31.2 48 31.203l-.36.007Z",
  fill: "#FF4F17",
  stroke: "#FF4F17",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 37,
  r: 3,
  fill: "#FF4F17"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.236 40.248a.864.864 0 0 1 .511.128 6.408 6.408 0 0 1 2.147 2.294c.5.922.761 1.953.76 3 0 .222-.09.435-.249.592a.85.85 0 0 1-.597.245H42.69a.851.851 0 0 1-.6-.245.836.836 0 0 1-.247-.593c0-1.047.263-2.077.765-2.999a6.416 6.416 0 0 1 2.126-2.288.873.873 0 0 1 1.001.057c.35.287.746.512 1.173.664a4.008 4.008 0 0 0 2.663 0 3.89 3.89 0 0 0 1.175-.664c.14-.113.31-.18.49-.191Z",
  fill: "#FF4F17"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.81 56.393H35.19a1.09 1.09 0 0 0-.767.315 1.072 1.072 0 0 0 0 1.52c.204.203.48.316.767.316h25.62c.288 0 .564-.113.767-.315a1.071 1.071 0 0 0 0-1.521 1.09 1.09 0 0 0-.767-.315ZM52.216 61.713H35.19a1.09 1.09 0 0 0-.767.315 1.071 1.071 0 0 0 0 1.521c.204.202.48.315.767.315h17.026c.287 0 .563-.113.767-.315a1.07 1.07 0 0 0 0-1.521 1.09 1.09 0 0 0-.767-.315ZM57.608 67.035h-22.47c-.57 0-1.032.459-1.032 1.025v.102c0 .566.462 1.024 1.033 1.024h22.47c.57 0 1.033-.458 1.033-1.024v-.103c0-.565-.463-1.024-1.034-1.024Z",
  fill: "#992525",
  stroke: "#992525"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.577 18.488H54.988v2.152h10.589c.597 0 1.17.235 1.593.654.422.42.66.987.66 1.58v49.074c0 .592-.238 1.16-.66 1.579a2.267 2.267 0 0 1-1.593.655H30.423c-.597 0-1.17-.237-1.592-.655a2.228 2.228 0 0 1-.661-1.58V22.875c0-.593.238-1.16.66-1.58a2.265 2.265 0 0 1 1.593-.654h10.744v-2.152H30.423a4.448 4.448 0 0 0-3.126 1.286 4.372 4.372 0 0 0-1.297 3.1v49.074a4.371 4.371 0 0 0 1.297 3.1 4.448 4.448 0 0 0 3.126 1.285h35.154a4.448 4.448 0 0 0 3.126-1.286 4.371 4.371 0 0 0 1.297-3.1V22.875a4.372 4.372 0 0 0-1.297-3.1 4.448 4.448 0 0 0-3.126-1.286Z",
  fill: "#992525",
  stroke: "#992525"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.44 15.873h-2.671a.52.52 0 0 0-.516.512v6.034h3.702v-6.034a.511.511 0 0 0-.516-.512Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.343 23.17h-3.505v-5.792a2.378 2.378 0 0 0-.705-1.679A2.42 2.42 0 0 0 49.44 15h-2.671c-.638 0-1.25.251-1.702.698a2.378 2.378 0 0 0-.707 1.687v5.792h-3.505a1.03 1.03 0 0 0-.723.297c-.192.19-.3.448-.3.717v.123c0 .269.108.526.3.717.192.19.452.297.723.297h14.488c.271 0 .531-.107.723-.297.192-.19.3-.448.3-.717v-.13c0-.268-.108-.526-.3-.716a1.03 1.03 0 0 0-.723-.298Zm-5.641-5.785v5.792h-3.198v-5.792a.262.262 0 0 1 .265-.263h2.67a.268.268 0 0 1 .263.263Z",
  fill: "#992525",
  stroke: "#992525"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "employee-graphic_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(26 15)",
  d: "M0 0h44v62.333H0z"
})))));
export default SvgEmployeeGraphic;